import './Footer.css';

const Footer = () => (
  <footer className="footer">
    <a href="https://github.com/moatezz" className="link footer__link">
      Moatezz Chabane
    </a>
  </footer>
);

export default Footer;
